import { Injectable } from '@angular/core';
import * as RouteConstants from '../constants/route.constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetGlobalCountriesDataResponseModel } from '../models/get-global-countries-data-response.model';
import { InitiativeDataModel } from '../models/initiatives-data.model';
import { FilterRequestModel } from '../models/filter-request.model';
import { FilterRequestMecsModel } from '../models/mecs-models/filter-request-mecs.model';
import { GetMecsGlobalCountriesDataResponseModel } from '../models/mecs-models/get-mecs-global-countries-data-response.model';
import { MecsGlobalOverviewSolutionsModel } from '../models/mecs-models/mecs-global-overview-solutions.model';
import { MecsRegionSolutionLaunchesModel } from '../models/mecs-models/mecs-region-solution-launches.model';
import { MecsOverviewSolutionCountryPhase } from '../models/mecs-models/mecs-overview-solution-country-phase.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private routeConstants = RouteConstants;

  constructor(private httpClient: HttpClient) { }

  getGlobalCountriesData(filterRequest: FilterRequestModel): Observable<GetGlobalCountriesDataResponseModel>{ 
    return this.httpClient.post<GetGlobalCountriesDataResponseModel>(this.routeConstants.GET_GLOBAL_COUNTRIES_DATA_ROUTE, filterRequest);
  }

  getInitiativeOptions(): Observable<InitiativeDataModel[]>{
    return this.httpClient.get<InitiativeDataModel[]>(this.routeConstants.GET_INITIATIVE_OPTIONS_ROUTE);
  }

  getMecsGlobalCountriesData(filterRequest: FilterRequestMecsModel): Observable<GetMecsGlobalCountriesDataResponseModel>{
    return this.httpClient.post<GetMecsGlobalCountriesDataResponseModel>(this.routeConstants.GET_MECS_GLOBAL_COUNTRIES_DATA_ROUTE, filterRequest);
  }
  
  getMecsOvervewSolutionLaunches(filterRequest: FilterRequestMecsModel): Observable<MecsRegionSolutionLaunchesModel[]>{
    return this.httpClient.post<MecsRegionSolutionLaunchesModel[]>(this.routeConstants.GET_MECS_OVERVIEW_SOLUTION_LAUNCHES, filterRequest);
  }
  
  getMecsOvervewSolutionCountryPhase(filterRequest: FilterRequestMecsModel): Observable<MecsOverviewSolutionCountryPhase[]>{
    return this.httpClient.post<MecsOverviewSolutionCountryPhase[]>(this.routeConstants.GET_MECS_OVERVIEW_SOLUTION_COUNTRY_PHASE, filterRequest);
  }
}
